import { ClientOrganizationRoleEnum } from '@DigitaleDoerfer/digitale-doerfer-api';

/**
 * Org roles allowed to manage an organization's content (posts, comments) — as
 * opposed to managing the organization itself, which only `Admin` may do.
 */
export const CONTENT_MANAGER_ROLES: ClientOrganizationRoleEnum[] = [
  ClientOrganizationRoleEnum.Admin,
  ClientOrganizationRoleEnum.Funker
];
